export const AUTH_CHECK_STATUS = 'AUTH_CHECK_STATUS'
export const AUTH_USER_LOGIN = 'AUTH_USER_LOGIN'
export const AUTH_USER_LOGOUT = 'AUTH_USER_LOGOUT'
